import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmEditorComponent } from './cm-editor.component';

@NgModule({
  declarations: [
    CmEditorComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CmEditorComponent
  ]
})
export class CmEditorModule { }
